import React from 'react';

import ElevatedCard from '@/components/ui/ElevatedCard';
import WidgetRow from '@/components/ui/WidgetRow';
import WidgetsCard from '@/components/ui/WidgetsCard';

export interface ProjectSummary {
  title: string;
  value: number | string;
}

export interface IProps {
  className?: string;
  title: string;
  leftProjectSummary: ProjectSummary;
  rightProjectSummary: ProjectSummary;
}

const InfoBox: React.FC<IProps> = ({
  className,
  title,
  leftProjectSummary,
  rightProjectSummary,
}) => {
  return (
    <WidgetsCard title={title} className={className}>
      <div className='flex flex-wrap justify-between webS:flex-nowrap webS:gap-1'>
        <ElevatedCard className='mobile:w-full min-w-[40%] flex-grow'>
          <WidgetRow
            title={leftProjectSummary.title}
            value={leftProjectSummary.value}
          />
        </ElevatedCard>
        <ElevatedCard className='mobile:w-full min-w-[40%] flex-grow'>
          <WidgetRow
            title={rightProjectSummary.title}
            value={rightProjectSummary.value}
          />
        </ElevatedCard>
      </div>
    </WidgetsCard>
  );
};

export default InfoBox;
